import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalvaribleService {
  private myGlobalVar = '';
  private endtime = '';
  private lastevent: Object;
  private legaldisclamer = true;
  private flagfordropdown = false;
  private checkbox = false;
  private selectEvent = false;
  private modalselectedvalue = true;
  private defaultEvents: any;
  private inputValue: any;
  private selectValue: any;

  // private messageSource = new BehaviorSubject(this.flagfordropdown);
  // currentMessage = this.messageSource.asObservable();
  constructor() { }

  public setMyGV(val: string) {
    this.myGlobalVar = val;
  }
  public getMyGV() {
    return this.myGlobalVar;
  }
  public setEndtime(val: string) {
    this.endtime = val;
  }
  public getEndtime() {
    return this.endtime;
  }
  public setLastEvent(val: Object) {
    this.lastevent = val;
  }
  public getLastEvent() {
    return this.lastevent;
  }
  public setlegaldisclamer(val: boolean) {
    this.legaldisclamer = val;
  }
  public getlegaldisclamer() {
    return this.legaldisclamer;
  }
  public setdropdownflag(val: boolean, valcheck: boolean) {
    this.flagfordropdown = val;
    this.checkbox = valcheck;
  }
  public getdropdownflag() {
    return this.flagfordropdown;
  }
  public setselectedComponnet(val: any) {
    this.selectEvent = val;
  }
  public getselectedComponnet() {
    return this.selectEvent;
  }
  public setmodalselectedvalue(val: boolean) {
    this.modalselectedvalue = val;
  }
  public getmodalselectedvalue() {
    return this.modalselectedvalue;
  }
  public setDefaultEvents(values: any) {
    this.defaultEvents = values;
  }
  public getDefaultEvents() {
    return this.defaultEvents;
  }
  public setInputValue(values: any) {
    this.inputValue = values;
  }
  public getInputValue() {
    return this.inputValue;
  }
  public setSelectValue(values: any) {
    this.selectValue = values;
  }
  public getSelectValue() {
    return this.selectValue;
  }
  // public changeMessage(message: string) {
  //   this.messageSource.next(message)
  // }
}
